import { render, staticRenderFns } from "./AddressSearchField.vue?vue&type=template&id=23af5c6b"
import script from "./AddressSearchField.vue?vue&type=script&lang=js"
export * from "./AddressSearchField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports